import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Home, Sparkles, Search } from "lucide-react";

export default function NotFoundPage() {
  useEffect(() => {
    document.body.setAttribute("data-dark", "true");
    return () => document.body.removeAttribute("data-dark");
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center px-5 lg:px-10 overflow-hidden bg-[#040914] text-white">
      <div className="aurora aurora-anim w-[600px] h-[600px] -top-40 -left-40 bg-[#52BFB8]/25" />
      <div className="aurora aurora-anim w-[500px] h-[500px] bottom-0 right-0 bg-[#3E9690]/20" style={{ animationDelay: "3s" }} />
      <div className="absolute inset-0 caribbean-grid opacity-50" />

      <div className="relative z-10 max-w-2xl mx-auto text-center" data-testid="notfound-page">
        <p className="text-xs tracking-[0.3em] uppercase text-[#52BFB8] font-semibold mb-4">
          PAGE NOT FOUND
        </p>

        <h1 className="font-cabinet text-7xl md:text-9xl font-bold tracking-tighter leading-none mb-2">
          <span className="bg-gradient-to-r from-[#52BFB8] via-[#6BD2CB] to-[#3E9690] bg-clip-text text-transparent">
            404
          </span>
        </h1>

        <h2 className="font-cabinet text-2xl md:text-3xl font-semibold text-white mt-6 mb-3">
          This page isn't in our portfolio.
        </h2>
        <p className="text-[#9BA8C4] text-lg max-w-md mx-auto mb-10">
          The link may be outdated, mistyped, or moved. Let's get you back on track.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link to="/" data-testid="notfound-home-cta" className="btn-aqua group">
            <Home className="w-4 h-4 mr-2" />
            Back to Home
          </Link>
          <Link to="/qualify" data-testid="notfound-qualify-cta" className="btn-ghost-aqua group">
            <Sparkles className="w-4 h-4 mr-2" />
            Start Pre-Qualification
          </Link>
        </div>

        <div className="mt-12 grid grid-cols-3 gap-3 max-w-md mx-auto">
          {[
            { to: "/how-it-works", label: "How It Works" },
            { to: "/faq", label: "FAQ" },
            { to: "/partners/verify", label: "Partners" },
          ].map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className="rounded-xl border border-white/10 bg-white/5 px-3 py-2.5 text-xs text-[#9BA8C4] hover:text-white hover:border-[#52BFB8]/40 transition-all"
              data-testid={`notfound-link-${l.to.replace(/\//g, "")}`}
            >
              {l.label}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
